import React from 'react';
import { IMatch } from '@/models/match';
import { IMatchLiveData } from '../models/match-live-data';
import { Label } from './text';
import Link from 'next/link';

const ScoreCard: React.FC<{ liveData: IMatchLiveData; matchData: IMatch }> = ({ liveData, matchData }) => {
	const getGoalScorerSide = (contestantId: string, goalType: string) => {
		const isHome = contestantId === matchData.homeContestant.contestantId;
		const isAway = contestantId === matchData.awayContestant.contestantId;

		if (goalType === 'G' || goalType === 'PG') return isHome ? 'home' : isAway ? 'away' : undefined;
		if (goalType === 'OG') return isHome ? 'away' : isAway ? 'home' : undefined;

		return undefined;
	};

	const getParentClass = (side?: 'home' | 'away') => {
		if (side === 'home') return 'w-1/2 ml-0 justify-end flex gap-4 mb-1 translate-x-8';
		if (side === 'away') return 'w-1/2 ml-[50%] flex mb-1 gap-4 -translate-x-8';
		return '';
	};

	const getChildClass = (side?: 'home' | 'away') => {
		return `w-16 text-center font-bold font-monospace ${side === 'home' ? 'order-1' : ''}`;
	};

	const getExtraTimeDisplay = (time: number, periodId: number) => {
		if ((periodId === 1 && time > 45) || (periodId === 2 && time > 90)) {
			const baseTime = periodId === 1 ? 45 : 90;
			return `${baseTime}+${time - baseTime}`;
		}
		return time;
	};

	return (
		<div className="bg-white py-4 rounded-b-md border -mt-2">
			{liveData.goal?.map((goal) => {
				const side = getGoalScorerSide(goal.contestantId, goal.type);
				return (
					<div className="bg-white w-full relative" key={goal.optaEventId}>
						<div className={getParentClass(side)}>
							<div className={getChildClass(side)}>
								{getExtraTimeDisplay(goal.timeMin, goal.periodId)}
								{"'"}
							</div>
							<div>
								<Link href={`/spelers/${goal.scorerUrl}`}>
									<Label>
										{goal.scorerName}{' '}
										{goal.type === 'OG' ? '(E.D.)' : goal.type === 'PG' ? '(P)' : ''}
									</Label>
								</Link>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default ScoreCard;
